import { Button, Form, Input, Modal } from "antd";
import { ICreateCustomer } from "../../models/Sale";
import { useCreateCustomer } from "../../query/SaleQuery";
import { notify } from "../../utils/toast";

interface ModalAddCustomerProps {
  open: boolean;
  onCancel: () => void;
  onSuccess: () => void;
}

const ModalAddCustomer = ({
  open,
  onCancel,
  onSuccess,
}: ModalAddCustomerProps) => {
  const [form] = Form.useForm();
  const createCustomer = useCreateCustomer();
  const handleOk = () => {
    form
      .validateFields()
      .then(async (values: ICreateCustomer) => {
        try {
          await createCustomer.mutateAsync(values);
          notify.success("Thêm khách hàng thành công");
          form.resetFields();
          onSuccess();
        } catch (error) {
          notify.error("Thêm khách hàng thất bại");
        } finally {
        }
      })
      .catch(() => {});
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="Thêm khách hàng"
      open={open}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Hủy
        </Button>,
        <Button key="submit" type="primary" onClick={handleOk}>
          Thêm
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical" style={{ marginTop: "20px" }}>
        <Form.Item
          label="Mã khách hàng"
          name="code"
          rules={[{ required: true, message: "Vui lòng nhập mã khách hàng" }]}
        >
          <Input placeholder="Nhập mã khách hàng" />
        </Form.Item>

        <Form.Item
          label="Tên khách hàng"
          name="name"
          rules={[{ required: true, message: "Vui lòng nhập tên khách hàng" }]}
        >
          <Input placeholder="Nhập tên khách hàng" />
        </Form.Item>

        <Form.Item
          label="Địa chỉ"
          name="address"
          rules={[{ required: true, message: "Vui lòng nhập địa chỉ" }]}
        >
          <Input placeholder="Nhập địa chỉ" />
        </Form.Item>

        <Form.Item
          label="Mã số thuế"
          name="taxCode"
          rules={[{ required: true, message: "Vui lòng nhập mã số thuế" }]}
        >
          <Input placeholder="Nhập mã số thuế" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalAddCustomer;
